/** Every configured stocker bay has seven vertically stacked FOUP slots. */
export const STOCKER_RACK_LEVELS = 7;

/** Normalize the supported physical bay configurations. */
export function resolveStockerBayCount(bayCount?: string | number): number {
  const parsed = Math.floor(Number(bayCount));
  return parsed === 6 || parsed === 8 ? parsed : 4;
}

/** Total physical FOUP slots represented by a stocker's bay configuration. */
export function resolveStockerSlotCapacity(bayCount?: string | number): number {
  return STOCKER_RACK_LEVELS * resolveStockerBayCount(bayCount);
}
